module.exports = __webpack_public_path__ + "img/IMG_1645.9ae2a5e0.webp";